import PageLayout from "components/shared/pageLayout/PageLayout";
import Doubler from "components/doubler/Doubler";

function Verdubbelaar() {
    return (
        <PageLayout
            slug="verdubbelaar"
            title="Verdubbelaar | Lees! Cadeau"
            description="Vul je kaartnummer in en maak kans op een verdubbeling van het waarde op jouw Lees! Cadeau kaart."
        >
            <Doubler />
        </PageLayout>
    );
}

export default Verdubbelaar;
